import React, { useEffect, useRef, useState } from 'react'
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useForm } from 'react-hook-form';
import ApiHelper from '../../helperFunction/ApiHelper';
import API_ENDPOINTS from '../../helperFunction/Constant';
import { Toast } from 'primereact/toast';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { useParams } from 'react-router-dom';
import { confirmDialog } from 'primereact/confirmdialog';
import { motion, AnimatePresence } from 'framer-motion'
import VideoPlayer from '../common/VideoPlayer';
import Player from '@vimeo/player';

const ContentAddEdit = () => {

    const { id } = useParams()

    const toast = useRef(null)

    const [visible, setVisible] = useState(false)

    const [sections, setSections] = useState([])
    const [editingSection, setEditingSection] = useState(null)
    const [editingVideo, setEditingVideo] = useState(null)
    const [newSectionName, setNewSectionName] = useState('')
    const [sectionNameDraft, setSectionNameDraft] = useState('')
    const [newVideo, setNewVideo] = useState({
        name: '',
        videoUrl: '',
        duration: '',
        isActive: true,
    })
    const numProps = (e) => ['e', 'E', '+', '-'].includes(e.key) && e.preventDefault()

    const schema = yup.object({
        courseSectionId: yup.string().optional().nullable(),
        sectionName: yup.string().required("Name is required"),
        isActive: yup.boolean().optional(),
    });

    const { register, handleSubmit, reset, formState: { errors }, } = useForm({ resolver: yupResolver(schema), });

    const resetValue = () => {
        reset({
            courseSectionId: null,
            sectionName: '',
            isActive: ''
        })
    }

    useEffect(() => {
        getSectionData()
    }, [])

    const getSectionData = () => {
        ApiHelper.get(`${API_ENDPOINTS.COURSES_SECTION}/${id}`).then((res) => {
            if (res.status === 200) {
                setSections((prevSections) => {
                    const newSections = res.data.data || [];
                    return newSections.map(ns => {
                        const prevSection = prevSections.find(ps => ps.courseSectionId === ns.courseSectionId);
                        return {
                            ...ns,
                            isExpanded: prevSection ? prevSection.isExpanded : true
                        }
                    });
                })
            }
        }).catch((error) => {
            console.log("Error: ", error);
        })
    }

    // const getSectionVideos = (sectionId) => {
    //     ApiHelper.get(`${API_ENDPOINTS.COURSES_VIDEO}/${sectionId}`).then((res) => {
    //         if (res.status === 200) {
    //             setSections((prev) => prev.map((s) => s.courseSectionId === sectionId ? { ...s, videos: res.data.data }: s ))
    //         }
    //     }).catch((error) => {
    //         console.log("Error: ", error);
    //     })
    // }

    const handleEdit = (data) => {
        setVisible(true)
        reset({
            courseSectionId: data.courseSectionId,
            sectionName: data.sectionName,
            isActive: data.isActive
        })
    }

    const onSubmit = (data) => {
        add(data)
    };

    const addVideo = (videoData, courseSectionId) => {
        const obj = {
            videoUrl: videoData.videoUrl,
            videoName: videoData.name,
            videoDuration: videoData?.duration || 0,
            videoOrder: 0,
            isActive: videoData.isActive,
            courseId: id
        }
        ApiHelper.post(`${API_ENDPOINTS.COURSES_VIDEO}/${courseSectionId}`, obj).then((res) => {
            if (res.status === 200) {
                toast.current.show({ severity: 'success', summary: 'Success', detail: res.data.message, life: 3000 })
                getSectionData()
                resetVideoForm()
            }
        }).catch((error) => {
            toast.current.show({ severity: 'error', summary: 'Error', detail: error.response?.data?.message || 'Error', life: 3000 })
        })
    };

    const updateVideo = (videoData, courseVideoId, courseSectionId) => {
        const obj = {
            courseSectionId: courseSectionId,
            videoUrl: videoData.videoUrl,
            videoName: videoData.name,
            videoDuration: videoData?.duration || 0,
            videoOrder: 0,
            isActive: videoData.isActive,
            courseVideoId: courseVideoId,
            courseId: id
        }
        console.log('Updating video with id:', courseVideoId, 'Payload:', obj);
        ApiHelper.put(`${API_ENDPOINTS.COURSES_VIDEO}/${courseVideoId}`, obj).then((res) => {
            console.log('Update response:', res);
            if (res.status === 200) {
                toast.current.show({ severity: 'success', summary: 'Success', detail: res.data.message || 'Video updated successfully', life: 3000 })
                getSectionData()
                resetVideoForm()
            }
        }).catch((error) => {
            console.log('Update error:', error);
            toast.current.show({ severity: 'error', summary: 'Error', detail: error.response?.data?.message || 'Error updating video', life: 3000 })
        })
    };

    const add = (data) => {
        data.sectionOrder = 0
        data.isActive = true
        ApiHelper.post(`${API_ENDPOINTS.COURSES_SECTION}/${id}`, data).then((res) => {
            if (res.status === 200) {
                toast.current.show({ severity: 'success', summary: 'Success', detail: res.data.message, life: 3000 })
                getSectionData()
                reset()
            }
        }).catch((error) => {
            toast.current.show({ severity: 'error', summary: 'Error', detail: error.response.data.message, life: 3000 })
        })
    };

    const update = (data, courseSectionId) => {
        const obj = {
            sectionName: data
        }
        ApiHelper.put(`${API_ENDPOINTS.COURSES_SECTION}/${courseSectionId}`, obj).then((res) => {
            if (res.status === 200) {
                toast.current.show({ severity: 'success', summary: 'Success', detail: res.data.message, life: 3000 })
                getSectionData()
                setVisible(false)
                setSections([])
                setEditingSection(null)
                setSectionNameDraft('')
            }
        }).catch((error) => {
            toast.current.show({ severity: 'error', summary: 'Error', detail: error.response.data.message, life: 3000 })
        })
    };

    const confirmDeleteDailog = (courseSectionId) => {
        confirmDialog({
            message: 'Do you want to delete this record?',
            header: 'Delete Confirmation',
            icon: 'pi pi-info-circle',
            defaultFocus: null,
            acceptClassName: 'p-button-danger',
            accept: () => deleteSectionHandler(courseSectionId),
        });
    };

    const deleteSectionHandler = (courseSectionId) => {
        ApiHelper.delete(`${API_ENDPOINTS.COURSES_SECTION}/${courseSectionId}`).then((res) => {
            if (res.status === 200) {
                toast.current.show({ severity: 'success', summary: 'Success', detail: res.data.message, life: 3000 });
                getSectionData();
                setSections([])
            }
        }).catch((err) => {
            toast.current.show({ severity: 'error', summary: 'Error', detail: err.response?.data?.message, life: 3000 });
        });
    };

    const deleteCourseVideo = (courseVideoId) => {
        ApiHelper.delete(`${API_ENDPOINTS.COURSES_VIDEO}/${courseVideoId}`).then((res) => {
            if (res.status === 200) {
                toast.current.show({ severity: 'success', summary: 'Success', detail: res.data.message, life: 3000 });
                getSectionData();
            }
        }).catch((err) => {
            toast.current.show({ severity: 'error', summary: 'Error', detail: err.response?.data?.message, life: 3000 });
        });
    };

    const confirmDeleteVideoDialog = (courseVideoId) => {
        confirmDialog({
            message: 'Do you want to delete this video?',
            header: 'Delete Confirmation',
            icon: 'pi pi-info-circle',
            defaultFocus: null,
            acceptClassName: 'p-button-danger',
            accept: () => deleteCourseVideo(courseVideoId),
        });
    };

    const startEditSection = (sectionId, currentName) => {
        setEditingSection(sectionId)
        setSectionNameDraft(currentName)
    }
    const saveSectionName = (sectionId) => {
        if (!sectionNameDraft.trim()) return
        update(sectionNameDraft, sectionId)
        const updatedSections = sections.map((s) =>
            s.courseSectionId === sectionId
                ? {
                    ...s,
                    sectionName: sectionNameDraft,
                }
                : s,
        )
        setSections(updatedSections)
        setEditingSection(null)
        setSectionNameDraft('')
    }
    const toggleSection = (sectionId) => {
        console.log('inside toggle section');
        const updatedSections = sections.map((s) =>
            s.courseSectionId === sectionId
                ? {
                    ...s,
                    isExpanded: !s.isExpanded,
                }
                : s,
        )
        setSections(updatedSections)
    }
    const startEditVideo = (courseSectionId, video) => {
        setEditingVideo({
            courseSectionId,
            videoId: video.courseVideoId,
        })
        setNewVideo({
            name: video.videoName,
            videoUrl: video.videoUrl,
            duration: video.videoDuration,
            isActive: video.isActive,
        })
    }
    const resetVideoForm = () => {
        setEditingVideo(null)
        setNewVideo({
            name: '',
            videoUrl: '',
            duration: '',
            isActive: true,
        })
    }
    const saveVideo = (courseSectionId) => {
        if (!newVideo.name.trim()) {
            return toast.current.show({ severity: 'error', summary: 'Error', detail: 'Video Name is required', life: 3000 });
        }
        if (!newVideo.videoUrl.trim()) {
            return toast.current.show({ severity: 'error', summary: 'Error', detail: 'Video URL is required', life: 3000 });
        }
        if(!newVideo.duration) {
            return toast.current.show({ severity: 'error', summary: 'Error', detail: 'Video Duration is required', life: 3000 })
         }
        const isEditing = !!editingVideo?.videoId

        console.log('saveVideo called. isEditing:', isEditing, 'editingVideo:', editingVideo, 'newVideo:', newVideo);

        if (isEditing) {
            updateVideo(newVideo, editingVideo.videoId, courseSectionId)
        } else {
            addVideo(newVideo, courseSectionId)
        }
    }

    const formatDuration = (seconds) => {
        const hours = Math.floor(seconds / 3600);
        const minutes = Math.floor((seconds % 3600) / 60);
        if (hours > 0) {
            return `${hours}h ${minutes}m`;
        }

        return `${minutes}m`;
    }

    return (
        <>
            <Toast ref={toast} />
            {/* Add Section use schema*/}
            {console.log('errors ', errors)}
            <form className="mb-6 " onSubmit={handleSubmit(onSubmit)}>
                <div className="d-flex gap-2">
                    <div className="col-md-6">
                        <label className='form-label'>Section Name</label>
                        <input type="text" name="sectionName" className="form-control" {...register("sectionName")} />
                        <small className="text-danger">{errors.sectionName?.message}</small>
                    </div>
                    <div className="col-md-6">
                        <button
                            style={{ marginTop: '22px' }}
                            type="submit"
                            className="d-flex ms-3 justify-content-center align-items-center gap-2 px-4 py-2 btn btn-primary text-sm font-medium"
                        >
                            <i class="pi pi-plus"></i>
                            Add Section
                        </button>
                    </div>

                </div>
            </form>

            {/* Sections List */}
            <div className="space-y-4">
                {console.log('sections: ', sections)}

                {sections?.map((section, sectionIndex) => (
                    <div
                        key={section.courseSectionId}
                        className="border border-gray-200 rounded-lg overflow-hidden"
                    >
                        {/* Section Header */}
                        <div className="d-flex align-items-center justify-between p-4 bg-gray-50">
                            <div className="d-flex align-items-center gap-3 flex-1">
                                <div
                                    onClick={() => toggleSection(section.courseSectionId)}
                                    className="p-1 hover:bg-gray-200 rounded transition-colors"
                                >
                                    {section.isExpanded ? (
                                        <i className='pi pi-chevron-down'></i>
                                    ) : (
                                        <i className='pi pi-chevron-right'></i>
                                    )}
                                </div>
                                <div className="flex-1">
                                    {editingSection === section.courseSectionId ? (
                                        <div className="d-flex align-items-center gap-2">
                                            <input
                                                type="text"
                                                autoFocus
                                                value={sectionNameDraft}
                                                onChange={(e) => setSectionNameDraft(e.target.value)}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') saveSectionName(section.courseSectionId)
                                                    if (e.key === 'Escape') setEditingSection(null)
                                                }}
                                                className="flex-1 px-3 py-1.5 border border-gray-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
                                            />
                                            <button
                                                onClick={() => update(sectionNameDraft, section.courseSectionId)}
                                                className="p-1.5 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 transition-colors"
                                                aria-label="Save section name"
                                            >
                                                <i className='pi pi-check'></i>
                                                {/* <Check className="w-4 h-4" /> */}
                                            </button>
                                            <button
                                                onClick={() => setEditingSection(null)}
                                                className="p-1.5 border border-gray-200 rounded-lg hover:bg-gray-100 transition-colors"
                                                aria-label="Cancel"
                                            >
                                                <i className='pi pi-times'></i>
                                                {/* <X className="w-4 h-4 text-gray-600" /> */}
                                            </button>
                                        </div>
                                    ) : (
                                        <>
                                            <h4 className="font-medium text-gray-900">
                                                Section {sectionIndex + 1}: {section.sectionName}
                                            </h4>
                                            <p className="text-sm text-gray-500">
                                                {section?.courseVideos?.length || 0} videos •{' '} {formatDuration(section?.totalDuration)}
                                            </p>
                                        </>
                                    )}
                                </div>
                            </div>
                            {editingSection !== section.courseSectionId && (
                                <div className="d-flex align-items-center gap-1">
                                    <div
                                        onClick={() =>
                                            startEditSection(section.courseSectionId, section.sectionName)
                                        }
                                        className="p-2 hover:bg-gray-200 rounded transition-colors"
                                        aria-label="Edit section"
                                    >
                                        <i className='pi pi-pencil'></i>
                                        {/* <Edit className="w-4 h-4 text-gray-600" /> */}
                                    </div>
                                    <div
                                        onClick={() => confirmDeleteDailog(section.courseSectionId)}
                                        className="p-2 hover:bg-red-50 rounded transition-colors"
                                        aria-label="Delete section"
                                    >
                                        <i className='pi pi-trash'></i>
                                        {/* <Trash2 className="w-4 h-4 text-red-600" /> */}
                                    </div>
                                </div>
                            )}
                        </div>

                        {/* Section Content */}
                        <AnimatePresence>
                            {section.isExpanded && (
                                <motion.div
                                    initial={{
                                        height: 0,
                                        opacity: 0,
                                    }}
                                    animate={{
                                        height: 'auto',
                                        opacity: 1,
                                    }}
                                    exit={{
                                        height: 0,
                                        opacity: 0,
                                    }}
                                    transition={{
                                        duration: 0.2,
                                    }}
                                    className="overflow-hidden"
                                >
                                    <div className="p-4 space-y-3">
                                        {/* Videos List */}
                                        {section?.courseVideos?.map((video) =>
                                            editingVideo?.courseSectionId === section.courseSectionId &&
                                                editingVideo?.videoId === video.courseVideoId ? (
                                                <VideoForm
                                                    key={video.courseVideoId}
                                                    newVideo={newVideo}
                                                    setNewVideo={setNewVideo}
                                                    onSave={() => saveVideo(section.courseSectionId)}
                                                    onCancel={resetVideoForm}
                                                    saveLabel="Save Changes"
                                                />
                                            ) : (
                                                <div
                                                    key={video.courseVideoId}
                                                    className="flex items-center gap-3 p-3 bg-white border border-gray-200 rounded-lg"
                                                >
                                                    <i className='pi pi-video'></i>
                                                    {/* <Video className="w-5 h-5 text-gray-400 flex-shrink-0" /> */}
                                                    <div className="flex-1 min-w-0">
                                                        <p className="font-medium text-gray-900 truncate">
                                                            {video.videoName}
                                                        </p>
                                                        <p className="text-sm text-gray-500">
                                                            {formatDuration(video.videoDuration)} •{' '}
                                                            {video.isActive ? 'Active' : 'Inactive'}
                                                        </p>
                                                    </div>
                                                    <button
                                                        onClick={() => startEditVideo(section.courseSectionId, video)}
                                                        className="p-2 hover:bg-gray-100 rounded transition-colors flex-shrink-0"
                                                        aria-label="Edit video"
                                                    >
                                                        <i className='pi pi-pencil'></i>
                                                        {/* <Edit className="w-4 h-4 text-gray-600" /> */}
                                                    </button>
                                                    <button
                                                        onClick={() => confirmDeleteVideoDialog(video.courseVideoId)}
                                                        className="p-2 hover:bg-red-50 rounded transition-colors flex-shrink-0"
                                                        aria-label="Delete video"
                                                    >
                                                        <i className='pi pi-trash'></i>
                                                        {/* <Trash2 className="w-4 h-4 text-red-600" /> */}
                                                    </button>
                                                </div>
                                            ),
                                        )}

                                        {/* Add Video: show form when adding new, button otherwise.
                            When editing an existing video the inline form renders
                            in place of that video row above. */}
                                        {editingVideo?.courseSectionId === section.courseSectionId &&
                                            !editingVideo?.videoId ? (
                                            <VideoForm
                                                newVideo={newVideo}
                                                setNewVideo={setNewVideo}
                                                onSave={() => saveVideo(section.courseSectionId)}
                                                onCancel={resetVideoForm}
                                                saveLabel="Add Video"
                                            />
                                        ) : editingVideo?.courseSectionId !== section.courseSectionId ? (
                                            <button
                                                onClick={() =>
                                                    setEditingVideo({
                                                        courseSectionId: section.courseSectionId,
                                                        videoId: '',
                                                    })
                                                }
                                                className="w-full flex items-center justify-center gap-2 p-3 border-2 border-dashed border-gray-300 rounded-lg hover:border-indigo-400 hover:bg-indigo-50 transition-colors text-sm font-medium text-gray-600"
                                            >
                                                <i className='pi pi-plus'></i>
                                                {/* <Plus className="w-4 h-4" /> */}
                                                Add Video
                                            </button>
                                        ) : null}
                                    </div>
                                </motion.div>
                            )}
                        </AnimatePresence>
                    </div>
                ))}
            </div>

            {sections.length === 0 && (
                <div className="text-center py-5 text-gray-500">
                    <p>
                        No sections added yet. Create your first section to get started.
                    </p>
                </div>
            )}
            {/* <div>
                <div className='d-flex' style={{justifyContent:'end'}}>
                    <button className={`${ visible ? 'd-none' : ''} btn btn-primary btn mt-3`} onClick={() => { setVisible(true); resetValue() }}>Add</button>
                    <button className={`${ !visible ? 'd-none' : ''} btn btn-danger btn`} onClick={() => { setVisible(false); resetValue() }}>&times;</button>
                </div>
                <div className={`${!visible ? 'd-none' : ''}`}>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <div class="row mb-3">
                            <div class="col-md-3 mb-3">
                                <label class="form-label">Name</label>
                                <input type="text" name="sectionName" class="form-control" {...register("sectionName")} />
                                <small className="text-danger">{errors.sectionName?.message}</small>
                            </div>
                            <div class="col-md-3 mb-3">
                                <label class="form-label">Order</label>
                                <input type="number" onKeyDown={numProps} name="SectionOrder" class="form-control" {...register("sectionOrder", { valueAsNumber: true, })} />
                                <small className="text-danger">{errors.sectionOrder?.message}</small>
                            </div>
                            <div class="col-md-3">
                                <label class="form-label">Status</label>
                                <div class="form-check form-switch mb-2">
                                    <input class="form-check-input mt-2" name="isActive" type="checkbox" id="flexSwitchCheckDefault" {...register("isActive")} />
                                </div>
                            </div>
                            <div>
                                <input type="hidden" class="form-control" {...register("courseSectionId")} />
                            </div>
                        </div>
                        <div class="mt-4">
                            <button type="submit" class="btn btn-primary me-3">Save</button>
                            <button type="button" onClick={() => resetValue()} class="btn btn-secondary reset-btn">Reset</button>
                        </div>
                    </form>
                </div>
            </div> */}
            {/* <div className='mt-5'>
                <DataTable globalFilter={globalFilterValue} header={header}paginator rows={50} rowsPerPageOptions={[50, 100, 150, 200]} showGridlines size="small" value={contentData} tableStyle={{ minWidth: '50rem' }} >
                    <Column sortable body={serialNoTemplate} header='S.NO' />
                    <Column sortable header='Name' field='sectionName' />
                    <Column sortable header='Order' field='sectionOrder' />
                    <Column sortable header='Status' body={statusBodyTemplate} />
                    <Column sortable header='Action' body={actionBodyTemplate} />
                </DataTable>
            </div> */}
        </>
    )
}

const VideoForm = ({ newVideo, setNewVideo, onSave, onCancel, saveLabel, }) => {
    const iframeRef = useRef(null);

    useEffect(() => {
        if (newVideo.videoUrl && newVideo.videoUrl.includes('https://player.vimeo.com/')) {
            const getDuration = async () => {
                try {
                    const player = new Player(iframeRef.current);
                    const duration = await player.getDuration();
                    if (duration) {
                        setNewVideo((prev) => ({ ...prev, duration: duration.toString() }));
                    }
                } catch (error) {
                    console.error('Error getting Vimeo duration:', error);
                }
            };

            // Give the iframe a tiny bit of time to render and initialize
            const timer = setTimeout(getDuration, 500);
            return () => clearTimeout(timer);
        }
    }, [newVideo.videoUrl, setNewVideo]);

    return (
        <div className="p-4 bg-gray-50 rounded-lg space-y-3 border border-gray-200">
            <div className='row'>
                <div className='d-flex justify-content-space-between gap-0'>
                    <div className='col-md-7'>
                        <div className='col-md-11 mb-2'>
                            <input
                                type="text"
                                autoFocus
                                value={newVideo.name}
                                onChange={(e) =>
                                    setNewVideo({
                                        ...newVideo,
                                        name: e.target.value,
                                    })
                                }
                                placeholder="Video name"
                                className="w-full px-4 py-2 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
                            />
                        </div>
                        <div className='col-md-11 mb-2'>
                            <input
                                type="url"
                                pattern="https?:\/\/player\.vimeo\.com\/video\/\d+(?:\?.*)?"
                                value={newVideo.videoUrl}
                                onChange={(e) =>
                                    setNewVideo({
                                        ...newVideo,
                                        videoUrl: e.target.value,
                                    })
                                }
                                placeholder="Video URL"
                                className="w-full px-4 py-2 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
                            />
                        </div>
                        <div className='col-md-11 mb-2'>
                            <input
                                type="number"
                                value={newVideo.duration}
                                onChange={(e) =>
                                    setNewVideo({
                                        ...newVideo,
                                        duration: e.target.value,
                                    })
                                }
                                readOnly
                                placeholder="Duration (e.g., 230 - in seconds)"
                                className="w-full px-4 py-2 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
                            />
                        </div>
                        <div className='col-md-11 mb-2'>
                            <label className="flex items-center gap-2">
                                <input
                                    type="checkbox"
                                    checked={newVideo.isActive}
                                    onChange={(e) =>
                                        setNewVideo({
                                            ...newVideo,
                                            isActive: e.target.checked,
                                        })
                                    }
                                    className="w-4 h-4 text-indigo-600 border-gray-300 rounded focus:ring-indigo-500"
                                />
                                <span className="text-sm text-gray-700">Active</span>
                            </label>
                            <div className="flex gap-2">
                                <button onClick={onSave} className="flex-1 px-4 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 transition-colors text-sm font-medium" >
                                    {saveLabel}
                                </button>
                                <button
                                    onClick={onCancel}
                                    className="px-4 py-2 border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors text-sm font-medium"
                                >
                                    Cancel
                                </button>
                            </div>
                        </div>
                    </div>
                    <div>
                        <iframe
                            ref={iframeRef}
                            src={newVideo.videoUrl}
                            style={{ position: 'absolute', opacity: 0, width: '1px', height: '1px', pointerEvents: 'none', zIndex: -100 }}
                            frameBorder="0"
                            allow="autoplay; fullscreen; picture-in-picture"
                            title="hidden-vimeo-player"
                        ></iframe>
                        {/* <VideoPlayer url={newVideo.videoUrl} getDuration={(videoDuration) => setNewVideo((prev) => ({ ...prev, duration: videoDuration }))}  /> */}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ContentAddEdit